import React, { useContext, useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import HeaderTwo from "../../../components/header/HeaderTwo";
import FooterTwo from "../../../components/footer/FooterTwo";
import CopyRightTwo from "../../../components/footer/CopyRightTwo";
import { useParams } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { Storecontext } from "../../../Context/Storecontext";
import "./BlogDisplay.css";

const BlogDisplay = () => {
  const { slug } = useParams();
  const { url } = useContext(Storecontext);
  const token = localStorage.getItem("token");

  const [blogById, setBlogById] = useState(null);
  const [similarBlogs, setSimilarBlogs] = useState([]);
  const [tableOfContents, setTableOfContents] = useState([]);
  const contentRef = useRef(null);
  const tocRef = useRef(null);
  const processHTML = (html) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    const links = doc.querySelectorAll("a");

    links.forEach((a) => {
      if (a.getAttribute("target") === "_blank") {
        a.setAttribute("rel", "nofollow");
      }
    });

    return doc.body.innerHTML;
  };
  // Load AddToAny script
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://static.addtoany.com/menu/page.js";
    script.defer = true;
    document.body.appendChild(script);
  }, []);

  // Fetch blog
  useEffect(() => {
    const fetchBlog = async () => {
      try {
        const response = await axios.get(`${url}/api/user/view/${slug}`, {
          headers: { token },
        });
        if (response.data.success) {
          setBlogById(response.data.blogs);
          setSimilarBlogs(response.data.similarBlogs || []);
        } else {
          toast.error(response.data.message);
        }
      } catch (error) {
        console.error("Fetch blog error:", error);
        toast.error("Failed to fetch blog data.");
      }
    };

    if (slug) fetchBlog();
  }, [slug]);

  // Generate TOC from rendered HTML
  useEffect(() => {
    if (contentRef.current) {
      const headings = contentRef.current.querySelectorAll("h1, h2, h3");
      const tocItems = [];

      headings.forEach((heading, index) => {
        const text = heading.innerText;
        const slug = text
          .toLowerCase()
          .replace(/\s+/g, "-")
          .replace(/[^\w\-]+/g, "");
        const id = `${slug}-${index}`;
        heading.id = id;

        tocItems.push({
          id,
          text,
          tag: heading.tagName,
        });
      });

      setTableOfContents(tocItems);
    }
  }, [blogById?.content]);

  if (!blogById) return null;

  return (
    <>
      <div className="main-page-wrapper p0">
        <Helmet>
          {blogById?.metaDiscription && (
            <meta name="description" content={blogById.metaDiscription} />
          )}
          <title>{blogById.metaTitle || blogById.title}</title>
          {blogById?.metaKeywords && (
            <meta name="keywords" content={blogById.metaKeywords} />
          )}
        </Helmet>

        <HeaderTwo />

        <div className="fancy-hero-five bg-white">
          <img
            src="/images/shape/95.svg"
            alt="shape"
            className="shapes shape-one"
          />
          <img
            src="/images/shape/96.svg"
            alt="shape"
            className="shapes shape-two"
          />
          <div className="bg-wrapper">
            <div className="container">
              <div className="col-lg-10 m-auto text-center">
                <h6 className="page-title">Our Blog</h6>
                <h1 className="heading">
                  <span>
                    {blogById.title}
                    <img src="/images/shape/line-shape-11.svg" alt="" />
                  </span>
                </h1>
              </div>
            </div>
          </div>
        </div>

        <div className="blog-page-bg " style={{ padding: "50px 0" }}>
          <div className="container">
            <div className="blog-content-container ">
              {/* Sidebar TOC */}
              <div className="toc-sidebar">
                <div className="toc-content">
                  <h5>Table of Contents</h5>
                  <ul>
                    {/* TOC items here */}
                    {tableOfContents.map((item) => (
                      <li
                        key={item.id}
                        style={{
                          marginLeft: item.tag === "H3" ? "20px" : "0",
                          lineHeight: "1.4",
                          marginBottom: "8px",
                        }}
                      >
                        <a
                          href={`#${item.id}`}
                          className="toc-link"
                          onClick={(e) => {
                            e.preventDefault();
                            document.getElementById(item.id)?.scrollIntoView({
                              behavior: "smooth",
                            });
                          }}
                        >
                          {item.text}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              {/* Main Content */}
              <div className="blog-main-content feature-blog-one">
                <div className="feature-blog-one">
                  <div className="post-meta">
                    {blogById?.featuredImage && (
                      <img
                        src={blogById.featuredImage}
                        alt={blogById?.title || "blog"}
                        className="featured-image"
                      />
                    )}

                    <div ref={contentRef} id="blog-content">
                      <div
                        dangerouslySetInnerHTML={{
                          __html: processHTML(blogById.introduction),
                        }}
                      />
                      <br />
                      <div
                        dangerouslySetInnerHTML={{
                          __html: processHTML(blogById.content),
                        }}
                      />
                    </div>

                    {/* Social Share */}
                    <div className="a2a_kit a2a_kit_size_32 a2a_default_style mt-4">
                      <a className="a2a_button_facebook" />
                      <a className="a2a_button_twitter" />
                      <a className="a2a_button_whatsapp" />
                      <a className="a2a_button_linkedin" />
                      <a
                        className="a2a_dd"
                        href="https://www.addtoany.com/share"
                      />
                    </div>
                  </div>
                </div>

                {/* Similar Blogs */}
                {/* Similar Blogs */}
                {similarBlogs.length > 0 && (
                  <div className="post-meta mt-5">
                    <h4 className="mb-3">Related Articles</h4>
                    <div className="row">
                      {similarBlogs.map((blog) => (
                        <div
                          key={blog._id}
                          className="col-12 col-sm-6 col-md-6 mb-3"
                        >
                          <a
                            href={`/blog/${blog.url}`}
                            className="text-decoration-none text-dark"
                          >
                            <div className="related-image-wrapper">
  <img
    src={
      blog.featuredImage ||
      "/images/logo/defaultFeaturedImage.png"
    }
    alt={blog.title}
    className="related-image"
  />
  <div className="related-overlay">
    
    <h5 className="related-title">{blog.title}</h5>
  </div>
</div>

                          </a>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        <footer className="theme-footer-two pt-150 md-pt-80">
          <div className="top-footer">
            <div className="container">
              <FooterTwo />
            </div>
          </div>
          <div className="container">
            <div className="bottom-footer-content">
              <CopyRightTwo />
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default BlogDisplay;
